var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTelevision = function SvgIconTelevision(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.793 1.543a1 1 0 0 1 1.414 0L12 5.336l3.793-3.793a1 1 0 1 1 1.414 1.414L14.414 5.75h5.836c.966 0 1.75.784 1.75 1.75v11.25a1.75 1.75 0 0 1-1.75 1.75H3.75A1.75 1.75 0 0 1 2 18.75V7.5c0-.966.784-1.75 1.75-1.75h5.836L6.793 2.957a1 1 0 0 1 0-1.414M14.125 18.5H20V7.75h-5.875zm-2-10.75V18.5H4V7.75zm6.625 3.125a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  })));
};
export default SvgIconTelevision;